export default "/build/static/fonts/Whitney-BlackItal_Web.woff2";